/**
 * Comoro franc.
 */
export var KMF = {
  code: 'KMF',
  base: 10,
  exponent: 0
};